var _defs, _style, _g, _path, _g2, _g3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _g4, _g5, _path39, _path40, _path41, _path42, _path43, _path44, _g6, _g7, _path45, _path46, _path47, _path48, _g8, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _g9, _path62, _path63, _path64, _path65, _path66, _g10, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _g11, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _g12, _g13, _path99, _path100;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 172 146",
    width: 172,
    height: 146,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-527-788h1366v3181h-1366z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1 1h170.33v144.5h-170.33z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1 1h170.33v144.5h-170.33z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.37 130.63h168.96v14.87h-168.96z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m77.62 13.48h13.96v13.77h-13.96z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m83.38 14.78h17.05v30.2h-17.05z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.02 120.71h5.06v5.09h-5.06z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.99 119.86h25.59v12.17h-25.59z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.55 94.93h20.47v25.04h-20.47z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.69 96.12h5.76v5.79h-5.76z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.37 127.55h10.68v10.68h-10.68z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m152.42 93.02h4.05v4.06h-4.05z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m151.62 92.1h13.26v12.89h-13.26z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m155.98 79.29h6.49v3.67h-6.49z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m45.44 112.91h19.13v23.34h-19.13z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m47.13 114.88h5.26v5.28h-5.26z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#e2c0b2}.b{fill:#e55499}.c{fill:#fff}.d{fill:#dcadc5}.e{fill:#343c90}.f{fill:#1c1d52}.g{fill:#ffb111}.h{fill:#28b5c6}.i{fill:#e44592}.j{fill:#189a9b}.k{fill:#ffd049}.l{fill:#ffdda4}.m{fill:#8b8ab3}.n{fill:#f69276}.o{fill:#20225b}.p{fill:#00a7e6}.q{fill:#ffcc93}.r{fill:#fedbcd}.s{fill:#e44290}.t{fill:#e43e8f}.u{fill:#dcc5d1}")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp3)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m171.3 138.1c0 4.1-37.8 7.4-84.5 7.4-46.6 0-84.4-3.3-84.4-7.4 0-4.1 37.8-7.5 84.4-7.5 46.7 0 84.5 3.4 84.5 7.5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m100.4 24.3c0-7-5.7-12.8-12.8-12.8-7.1 0-12.8 5.8-12.8 12.8 0 10.3 12.7 20.7 12.7 20.7 0 0 12.9-10.3 12.9-20.7z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m79.6 26.7c0.5-6.3 4.5-9.6 11.6-11.6 1.5-0.4-1.6-1.7-4.5-1.6-5 0.2-9.1 4.1-9.1 9.1 0 2.5 1.9 6 2 4.1z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m96.1 14.8c0.8 3 1 6.1 0.8 9-0.2 2.1-0.5 4.1-1.3 6-0.9 2-2.2 3.7-3.6 5.4-2.3 2.6-5.2 5.2-8.6 5.8 2.3 2.5 4.1 4 4.1 4 0 0 12.9-10.3 12.9-20.7 0-3.8-1.6-7.2-4.3-9.5z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m95.5 23c0 4.2-3.4 7.6-7.7 7.6-4.2 0-7.6-3.4-7.6-7.6 0-4.2 3.4-7.7 7.6-7.7 4.3 0 7.7 3.5 7.7 7.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m143.8 123.4c0 1.1-0.8 1.9-1.8 1.9h-105.2c-1 0-1.9-0.8-1.9-1.9v-74.5c0-1 0.9-1.9 1.9-1.9h105.2c1 0 1.8 0.9 1.8 1.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m39.5 53.2h99.8v66.3h-99.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m152.2 131.4c0 1.6-1.3 3-2.9 3h-119.7c-1.6 0-3-1.4-3-3v-5.3c0-1.7 1.4-3 3-3h119.7c1.6 0 2.9 1.3 2.9 3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m39.5 72h22.4l-2.4-8.6h-20z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m69.3 98.3l-24.5 21.3h30.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m123.3 111.6l-13.8-14.7h-37.2l6.3 22.7h44.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m62.8 63.4l2.4 8.6h20.9l-8.2-8.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m62.8 75.2h-23.3v44.4h0.4l28.5-24.7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m106.5 93.8l-17.4-18.6h-23l5.3 18.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m98.7 53.2h-38.8l2 7h17.4l11.1 11.8h8.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m139.3 56.5l-12.8 12.9v24.4h12.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m58.6 60.2l-2-7h-17.1v7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m126.5 96.9v13.4l8.7 9.3h4.1v-22.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m123.3 96.9h-9.4l9.4 10z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m126.5 115v4.6h4.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m101.9 53.2v22h-8.5l17.5 18.6h12.4v-25.8l14.8-14.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m139.5 53.3h-100.2c-4.1 4-8.4 8.1-12.9 12h126.4c-4.7-3.9-9.1-8-13.3-12z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m50.2 53.3c-3.2 4-6.6 8.1-10.1 12h99.1c-3.7-3.9-7.1-8-10.4-12z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m62.6 53.3c-2.2 4-4.5 8.1-6.9 12h68.1c-2.5-3.9-4.9-8-7.2-12z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m74.2 53.3c-1.3 4-2.7 8.1-4 12h39.2c-1.4-3.9-2.8-8-4.1-12z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m85 53.3c-0.4 4-0.9 8.1-1.3 12h12.3c-0.5-3.9-0.9-8-1.3-12z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m26.5 65.2c0.1 3.8 3.1 6.8 6.8 6.8 3.7 0 6.7-3 6.8-6.8z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m40 65.2c0.1 4.4 3.6 7.9 7.9 7.9 4.2 0 7.7-3.5 7.8-7.9z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m55.6 65.2c0.2 4.1 3.4 7.3 7.3 7.3 3.9 0 7.1-3.2 7.2-7.3z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m70 65.3c0.2 3.8 3.2 6.8 6.8 6.8 3.7 0 6.7-3 6.9-6.8z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m139.4 65.1c-0.1 4.4-3.6 7.9-7.8 7.9-4.3 0-7.7-3.5-7.9-7.9z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m123.8 65.1c-0.1 4.1-3.3 7.3-7.2 7.3-4 0-7.2-3.2-7.3-7.3z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m109.4 65.2c-0.1 3.8-3.1 6.8-6.8 6.8-3.7 0-6.7-3-6.8-6.8z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m83.7 65.2c0.1 3.4 2.8 6.2 6.1 6.2 3.4 0 6.1-2.8 6.2-6.2z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m152.7 65.2c-0.1 3.7-3.1 6.7-6.7 6.7-3.7 0-6.7-3-6.8-6.7z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m38.6 131.7c0 0.2-0.2 0.3-0.3 0.3h-25c-0.2 0-0.3-0.1-0.3-0.3v-11.5c0-0.2 0.1-0.3 0.3-0.3h25c0.1 0 0.3 0.1 0.3 0.3z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m36.7 130.8c0 0.2-0.2 0.3-0.3 0.3h-3.8c-0.2 0-0.3-0.1-0.3-0.3v-3.4c0-0.1 0.1-0.3 0.3-0.3h3.8c0.1 0 0.3 0.2 0.3 0.3z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m19.8 128c0 0.2-0.1 0.3-0.3 0.3h-4.2c-0.2 0-0.3-0.1-0.3-0.3 0-0.1 0.1-0.2 0.3-0.2h4.2c0.2 0 0.3 0.1 0.3 0.2z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m19.8 129.1c0 0.2-0.1 0.3-0.3 0.3h-4.2c-0.2 0-0.3-0.1-0.3-0.3 0-0.1 0.1-0.3 0.3-0.3h4.2c0.2 0 0.3 0.2 0.3 0.3z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m19.8 130.2c0 0.2-0.1 0.3-0.3 0.3h-4.2c-0.2 0-0.3-0.1-0.3-0.3 0-0.2 0.1-0.3 0.3-0.3h4.2c0.2 0 0.3 0.1 0.3 0.3z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b",
    d: "m23.6 119.9h4.4v4.7h-4.4z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp7)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m16.2 122.7c1.1-1.1 2.9-0.6 2.9-1.5 0-0.8-4.8-0.4-4.8-0.4-0.1 0-0.1 0.1-0.1 0.2 0 0-0.4 4.6 0.1 4.8 0.6 0.2 0.8-2.1 1.9-3.1z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m38.3 119.9h-2c0 1.6 0 3.2-0.2 4.9-0.2 1.1-0.5 2.4-1.7 3.1-0.9 0.5-1.9 0.6-3 0.6-3.1 0-15.4 0-18.4 0.1v3.1c0 0.2 0.1 0.3 0.3 0.3h25c0.1 0 0.3-0.1 0.3-0.3v-11.5c0-0.2-0.2-0.3-0.3-0.3z"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m36 119.7c0 0.1-0.1 0.3-0.3 0.3h-19.8c-0.2 0-0.4-0.2-0.4-0.3v-24.5c0-0.1 0.2-0.3 0.4-0.3h19.8c0.2 0 0.3 0.2 0.3 0.3z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "k",
    d: "m31.3 113.7h0.6c1.3 0 2.4 1.1 2.4 2.5 0 1.3-1.1 2.4-2.4 2.4h-0.6c-1.3 0-2.4-1.1-2.4-2.4 0-1.4 1.1-2.5 2.4-2.5z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m22.6 115.2c0 0.1-0.1 0.3-0.3 0.3h-4.8c-0.1 0-0.3-0.2-0.3-0.3 0-0.2 0.2-0.4 0.3-0.4h4.8c0.2 0 0.3 0.2 0.3 0.4z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m22.6 116.4c0 0.2-0.1 0.3-0.3 0.3h-4.8c-0.1 0-0.3-0.1-0.3-0.3 0-0.2 0.2-0.3 0.3-0.3h4.8c0.2 0 0.3 0.1 0.3 0.3z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m22.6 117.6c0 0.2-0.1 0.3-0.3 0.3h-4.8c-0.1 0-0.3-0.1-0.3-0.3 0-0.2 0.2-0.3 0.3-0.3h4.8c0.2 0 0.3 0.1 0.3 0.3z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b",
    d: "m23.9 94.9h4.3v5.4h-4.3z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp9)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m35.7 94.9h-2.3v0.1c0 3.4 0.1 13.6-0.1 15.2-0.1 1.2-0.1 2.5-0.6 3.6-0.5 0.9-1.5 1.7-2.5 1.8-1.6 0.2-11.4 0.1-14.7 0.1v4c0 0.1 0.2 0.3 0.4 0.3h19.8c0.2 0 0.3-0.2 0.3-0.3v-24.5c0-0.1-0.1-0.3-0.3-0.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp10)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m19.2 98.4c1.2-1.2 3.3-0.7 3.3-1.7-0.1-0.9-5.4-0.5-5.4-0.5-0.2 0-0.2 0.1-0.2 0.2 0 0-0.5 5.3 0.1 5.5 0.7 0.3 1-2.4 2.2-3.5z"
  })))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m1 80.4h11.2v3.2h-11.2z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m12.2 132v-51.6h-3.4v55.1h31.1v-3.5z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m18.1 132.9c0 4.1-3.3 7.3-7.4 7.3-4.1 0-7.3-3.2-7.3-7.3 0-4.1 3.2-7.4 7.3-7.4 4.1 0 7.4 3.3 7.4 7.4z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m14.7 132.9c0 2.2-1.8 4-4 4-2.2 0-4-1.8-4-4 0-2.2 1.8-4 4-4 2.2 0 4 1.8 4 4z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp11)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "m",
    d: "m16 132.9c0 2.9-2.3 5.3-5.3 5.3-2.9 0-5.3-2.4-5.3-5.3 0-3 2.4-5.3 5.3-5.3 3 0 5.3 2.3 5.3 5.3zm-2 0c0-1.8-1.5-3.3-3.3-3.3-1.8 0-3.3 1.5-3.3 3.3 0 1.8 1.5 3.3 3.3 3.3 1.8 0 3.3-1.5 3.3-3.3z"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "n",
    d: "m154.4 133.9h2.4v1.1h-2.4z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m154.4 135c0 0-2.4 1.3-3.1 1.7-0.7 0.4-1.1 1.8 2.4 0.7 2.6-0.9 3.1-1 3.1-2.4z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "n",
    d: "m159.7 133.9h2.5v1.1h-2.5z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m162.2 135c0 0 2.3 1.3 3.1 1.7 0.6 0.4 1.1 1.8-2.4 0.7-2.7-0.9-3.2-1-3.2-2.4z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m152.6 103.7l1.6 30.4h2.9c0 0 0.4-24.9 1.2-24.9 0.8 0 1.2 24.9 1.2 24.9h2.9l1.2-30.3z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m163.6 103.8h-11l-1-18.4 4.1-0.7h5l3.7 0.7z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m160.2 84.4l-2.1 2.2-1.9-2.2 0.4-2.5h3.2z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m156.1 84.4l2 2.2-0.8 1.2-1.7-3.1z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m160.2 84.4l-2.1 2.2 0.8 1.3 1.8-3.2z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m158.3 88c0 0.1-0.1 0.2-0.2 0.2-0.2 0-0.3-0.1-0.3-0.2 0-0.2 0.1-0.3 0.3-0.3 0.1 0 0.2 0.1 0.2 0.3z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m158.3 89.1c0 0.2-0.1 0.3-0.2 0.3-0.2 0-0.3-0.1-0.3-0.3 0-0.1 0.1-0.2 0.3-0.2 0.1 0 0.2 0.1 0.2 0.2z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m158.3 90.3c0 0.1-0.1 0.3-0.2 0.3-0.2 0-0.3-0.2-0.3-0.3 0-0.1 0.1-0.3 0.3-0.3 0.1 0 0.2 0.2 0.2 0.3z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "g",
    d: "m153.6 92.1h9.3c1.1 0 2 0.9 2 2v8.9c0 1.1-0.9 2-2 2h-9.3c-1.1 0-2-0.9-2-2v-8.9c0-1.1 0.9-2 2-2z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp12)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m154.2 94.6c0.8-0.8 2.3-0.5 2.3-1.2 0-0.6-3.8-0.3-3.8-0.3-0.1 0-0.2 0.1-0.2 0.1 0 0-0.3 3.7 0.2 3.9 0.4 0.2 0.6-1.7 1.5-2.5z"
  })))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m163.4 103.8c0 0.1-0.1 0.2-0.2 0.2h-2.9c-0.1 0-0.2-0.1-0.2-0.2v-2.5c0-0.2 0.1-0.3 0.2-0.3h2.9c0.1 0 0.2 0.1 0.2 0.3z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m156.3 101.9c0 0.1-0.1 0.2-0.2 0.2h-2.8c-0.1 0-0.2-0.1-0.2-0.2 0-0.1 0.1-0.2 0.2-0.2h2.8c0.1 0 0.2 0.1 0.2 0.2z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m156.3 102.7c0 0.1-0.1 0.2-0.2 0.2h-2.8c-0.1 0-0.2-0.1-0.2-0.2 0-0.1 0.1-0.2 0.2-0.2h2.8c0.1 0 0.2 0.1 0.2 0.2z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m156.3 103.4c0 0.1-0.1 0.2-0.2 0.2h-2.8c-0.1 0-0.2-0.1-0.2-0.2 0-0.1 0.1-0.2 0.2-0.2h2.8c0.1 0 0.2 0.1 0.2 0.2z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b",
    d: "m156.9 92.1h2.7v3.3h-2.7z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp13)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m164.7 92.1h-1.3c-0.1 1.7 0 6.7-0.2 7.6-0.1 0.7-0.4 1.4-0.9 1.9-0.6 0.5-1.5 0.7-2.3 0.7-0.9 0-8.4 0-8.4 0v2.5c0 0.1 0.1 0.2 0.2 0.2h12.9c0.1 0 0.2-0.1 0.2-0.2v-12.5c0-0.1-0.1-0.2-0.2-0.2z"
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m153 103.3l-3.6-6.8 2.1-5.9c0.3-0.7-0.1-1.4-0.7-1.6-0.6-0.2-1.3 0.1-1.5 0.8l-2.3 6.4c-0.1 0.3-0.1 0.7 0.1 1l4.6 7z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m151.7 104.2c0 0 0.4 0.5 0.9 0.9 0.4 0.2 0.7 0.3 1.3 0.3 1.2 0 1.9 0 2.2 0 0.4 0 0.6-0.5 0-0.6-0.5 0-1.5 0-2-0.2-0.2-0.1-0.2-0.4-0.1-0.5 0.5-0.2 0.7-0.2 1-0.3 0.3-0.2 0.1-0.6-0.2-0.5-0.4 0-1 0.4-1.8 0z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m151.5 92.6l1.8-4.9c0.3-1.1-0.6-2.1-1.3-2.3-1.3-0.2-2.1 0.5-2.8 2.1-0.2 0.7-1.1 3.4-1.1 3.4z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m148.3 90.2c-0.1 0.4-0.2 0.7-0.2 0.7l3.4 1.7 0.3-0.8c-0.8-0.3-3.1-1.4-3.5-1.6z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m163.2 103.3l3.5-6.8-2.1-5.9c-0.2-0.7 0.1-1.4 0.7-1.6 0.7-0.2 1.4 0.1 1.6 0.8l2.3 6.4c0.1 0.3 0.1 0.7-0.1 1l-4.7 7z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m164.4 104.2c0 0-0.3 0.5-0.9 0.9-0.3 0.2-0.6 0.3-1.2 0.3-1.2 0-1.9 0-2.2 0-0.4 0-0.6-0.5 0-0.6 0.5 0 1.5 0 1.9-0.2 0.2-0.1 0.3-0.4 0.1-0.5-0.4-0.2-0.7-0.2-0.9-0.3-0.4-0.2-0.2-0.6 0.2-0.5 0.4 0 0.9 0.4 1.8 0z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m164.7 92.6l-1.8-4.9c-0.3-1.1 0.5-2.1 1.3-2.3 1.2-0.2 2.1 0.5 2.8 2.1 0.2 0.7 1.1 3.4 1.1 3.4z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m164.4 91.8l0.3 0.8 3.4-1.7-0.2-0.7z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m153.7 76.7c0-3.4 1.6-5.8 4.7-5.8 2.9 0 4.3 2.6 4.3 6 0 1.5-0.3 3.5-0.8 4.2-0.8 0.9-2.2 1.9-3.6 1.9-1.1 0-2.8-1-3.5-1.9-0.4-0.5-1.1-2.8-1.1-4.4z"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp14)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m160.3 81.4c-1.2 0.6-2.9 1.1-4.3 0.7 0.7 0.5 1.6 0.9 2.3 0.9 1.4 0 2.8-1 3.6-1.9 0.2-0.4 0.4-1 0.6-1.8-0.6 0.9-1.3 1.6-2.2 2.1z"
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m161.8 74.8c0 0-0.5 1.4-0.1 2.2 0.4 0.8 0.4 1.7 0.8 2 0 0 0.6-2.3 0.3-4.1z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m154.7 74.8c0 0 0.6 1.2 0.2 2-0.4 0.8-0.2 1.8-0.9 2.2 0 0-0.5-2.3-0.2-4.1z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m154.7 74.9c0 0 1.5-1 3-0.5 1.5 0.5 3.2 0.8 4.1 0.5h1c0 0-0.3-3-2.9-3.6 0 0-4-0.9-5.6 1.5-0.3 0.6-0.5 1.6-0.6 2.4z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m158.3 75.1c1.6 0 3.2 0.2 4.6 0.9-0.1-1.5-0.1-2.8-1-3.7-0.8-0.9-2.3-1.4-3.5-1.4-1.5 0-3 0.5-3.9 1.5-0.7 0.8-0.8 2.2-0.9 3.6 1.4-0.7 3-0.9 4.7-0.9z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m153.6 76c0 0 0.1 1.4 0.5 1.5 0.4 0.2 1.5-0.9 4.1-0.9 2.7 0 3.9 1 4.2 0.9 0.5-0.2 0.5-1.5 0.5-1.5 0 0-4.3-2.4-9.3 0z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m162.4 78.5c-0.1 0.6-0.5 1.4-0.1 1.4 0.5 0.1 0.9-0.6 1-1.2 0.2-0.6-0.1-1.1-0.5-1.2-0.4-0.1-0.3 0.4-0.4 1z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m154.1 78.5c0.2 0.6 0.6 1.4 0.1 1.4-0.4 0.1-0.9-0.6-1-1.2-0.1-0.6 0.2-1.1 0.6-1.2 0.4-0.1 0.2 0.4 0.3 1z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m64.6 135.8c0 0.3-0.2 0.5-0.5 0.5h-18.2c-0.3 0-0.5-0.2-0.5-0.5v-22.4c0-0.3 0.2-0.5 0.5-0.5h18.2c0.3 0 0.5 0.2 0.5 0.5z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "k",
    d: "m46.7 114.2h16.5v20.8h-16.5z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m51.3 109.7h7.5v4.8h-7.5zm6.5 0.8h-5.5v3.2h5.5z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "f",
    d: "m50.4 113.4h9.2v2h-9.2z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m51.6 120.2q0 0 0 0h-2.9q-0.1 0-0.1 0v-2.8q0-0.1 0.1-0.1h2.9q0 0 0 0.1z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m61.6 118.1c0 0.2-0.2 0.4-0.4 0.4h-7.5c-0.2 0-0.4-0.2-0.4-0.4 0-0.2 0.2-0.4 0.4-0.4h7.5c0.2 0 0.4 0.2 0.4 0.4z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m61.6 119.4c0 0.2-0.2 0.4-0.4 0.4h-7.5c-0.2 0-0.4-0.2-0.4-0.4 0-0.1 0.2-0.3 0.4-0.3h7.5c0.2 0 0.4 0.2 0.4 0.3z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m51.6 124.6q0 0 0 0h-2.9q-0.1 0-0.1 0v-2.8q0-0.1 0.1-0.1h2.9q0 0 0 0.1z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m61.6 122.5c0 0.2-0.2 0.4-0.4 0.4h-7.5c-0.2 0-0.4-0.2-0.4-0.4 0-0.2 0.2-0.4 0.4-0.4h7.5c0.2 0 0.4 0.2 0.4 0.4z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m61.6 123.9c0 0.2-0.2 0.3-0.4 0.3h-7.5c-0.2 0-0.4-0.1-0.4-0.3 0-0.2 0.2-0.4 0.4-0.4h7.5c0.2 0 0.4 0.2 0.4 0.4z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m51.6 129q0 0 0 0h-2.9q-0.1 0-0.1 0v-2.8q0-0.1 0.1-0.1h2.9q0 0 0 0.1z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m61.6 126.9c0 0.2-0.2 0.4-0.4 0.4h-7.5c-0.2 0-0.4-0.2-0.4-0.4 0-0.2 0.2-0.3 0.4-0.3h7.5c0.2 0 0.4 0.1 0.4 0.3z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m61.6 128.3c0 0.2-0.2 0.3-0.4 0.3h-7.5c-0.2 0-0.4-0.1-0.4-0.3 0-0.2 0.2-0.4 0.4-0.4h7.5c0.2 0 0.4 0.2 0.4 0.4z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m51.6 133.4q0 0 0 0.1h-2.9q-0.1-0.1-0.1-0.1v-2.8q0-0.1 0.1-0.1h2.9q0 0 0 0.1z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m61.6 131.3c0 0.2-0.2 0.4-0.4 0.4h-7.5c-0.2 0-0.4-0.2-0.4-0.4 0-0.2 0.2-0.3 0.4-0.3h7.5c0.2 0 0.4 0.1 0.4 0.3z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m61.6 132.7c0 0.2-0.2 0.3-0.4 0.3h-7.5c-0.2 0-0.4-0.1-0.4-0.3 0-0.2 0.2-0.4 0.4-0.4h7.5c0.2 0 0.4 0.2 0.4 0.4z"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp15)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "m64.1 112.9h-2.8q0.4 1.9 0.4 3.8c0 4.7-1.9 9.2-5.3 12.5-2.9 3-6.8 4.8-11 5.2v1.4c0 0.3 0.2 0.5 0.5 0.5h18.2c0.3 0 0.5-0.2 0.5-0.5v-22.4c0-0.3-0.2-0.5-0.5-0.5z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp16)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m49.4 116.9c1.1-1.1 3-0.6 3-1.5 0-0.8-4.9-0.4-4.9-0.4-0.1 0-0.2 0.1-0.2 0.2 0 0-0.4 4.7 0.1 4.9 0.7 0.3 0.9-2.1 2-3.2z"
  }))), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m56.4 19.6c-0.1-2.4-2-4.4-4.3-4.4q-0.6 0-1.2 0.2c-0.9-1.8-2.7-3.1-4.8-3.1q-1.1 0-2.1 0.5c-1.1-1.6-2.9-2.7-5-2.7-2.8 0-5.1 2.1-5.9 4.8q-0.7-0.2-1.4-0.2c-2.5 0-4.5 2.2-4.6 4.9z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m146.1 12.6c-0.2-3-2.5-5.4-5.3-5.4q-0.8 0-1.6 0.2c-1.1-2.2-3.2-3.7-5.7-3.7q-1.4 0-2.6 0.6c-1.4-2-3.6-3.3-6.1-3.3-3.4 0-6.3 2.5-7.3 5.9q-0.8-0.3-1.6-0.3c-3.1 0-5.6 2.7-5.6 6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.05320775bf2f6e5c05b871353ba6e605.svg";
export { ForwardRef as ReactComponent };